import { render, staticRenderFns } from "./FilterFundsPill.vue?vue&type=template&id=576cc827&scoped=true"
import script from "./FilterFundsPill.vue?vue&type=script&lang=js"
export * from "./FilterFundsPill.vue?vue&type=script&lang=js"
import style0 from "./FilterFundsPill.vue?vue&type=style&index=0&id=576cc827&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576cc827",
  null
  
)

export default component.exports